
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as about3UEzfmzHHsH2brwDDK4AubJmgzzOzB7Qj_9ftzTFXwwMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/about.vue?macro=true";
import { default as indexRRDi5kU4RHJwqj9aIjyrxbqJiB2XiDz_i0sLW03eLr0Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/index.vue?macro=true";
import { default as _91slug_93IVgpcw7YC4n_45PAVrbjZvI5u1iHM_4DRLmrADk7_450ZrsMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/[slug].vue?macro=true";
import { default as faqs6lnki8Qnc0CRKeuzMm2238wWc9WIM_Gm7CPhX6Rj5RwMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/search/faqs.vue?macro=true";
import { default as newsVki8oJmWLpLnKDJBF7HNHiW_45WQat6yLlwDXaQxCa4oMMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/search/news.vue?macro=true";
import { default as drivers8dcQyB1HsiFA8P4vt9J_50Nl6L0HrxWN8W8PKaR7LecMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/search/drivers.vue?macro=true";
import { default as products9bfsYwvaACETWx1uGV2su8Le9Nf6hUmIy12YDfm_sO8Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/search/products.vue?macro=true";
import { default as search_453EFRECBTdt_iqoReGS4A5Daach_45te1GIsUeJeoxPIQMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/search.vue?macro=true";
import { default as contact_45usPz2yP_X8FbJM_bq8Xqnk1CM2LAaOrySSNeWBam96dEcMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/contact-us.vue?macro=true";
import { default as indexr7qCIckuoPLVHs8Q6jNAuFecuDdWsX9nhlrFhf_45A_45_45cMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/news/index.vue?macro=true";
import { default as e_45catalogue672Hzyge7hlmuz9ZMx2D4I97sXNR61P_ZQVu7_XkKyEMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/e-catalogue.vue?macro=true";
import { default as _91slug_93OnoEQ3hI9SoJ9RnbGXnMXPN1a6EUrz4QTLnEYXOjV1IMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/news/[slug].vue?macro=true";
import { default as indexTtUxegHZWSibiH8gccgcUZqYAbTRCIa88haamiZC10sMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/promo/index.vue?macro=true";
import { default as _91slug_938TlicBnXjIolz3GtGKu8LgLH0L5we24M_45b6bYXfzDKEMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/promo/[slug].vue?macro=true";
import { default as _91slug_93RuN9WKrheDHjnrnI7puqiqu6gAi7tVVA3x1T_90WZ8YMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/product/[slug].vue?macro=true";
import { default as indexPeiytfsmJDwYpxe6unj6UPHhlhL7TEjZp5rT3GZjENsMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/certificates/index.vue?macro=true";
import { default as indexgDRFPpC9yNcX9gq3w3cg16R9j6cQZWXNQcJLEZR6HEkMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/where-to-buy/index.vue?macro=true";
import { default as _91slug_939XS7JOltWI6dUECuYTx2U8ip5QBEQ1paHpQc0NiBrJoMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/certificates/[slug].vue?macro=true";
import { default as indexG4lCkteeRj5b8YvUoo38ejflkDuoH3h2Z0mYwg0Qc20Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/user-help-desk/index.vue?macro=true";
import { default as account_45removal_45requestTVING7vcIhfHAjceEW6Gb_KTAHJWt6_9MaWGxcKT2dkMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/account-removal-request.vue?macro=true";
import { default as indextGqyznEJX9wXqyVwEn7YfCrbfChtMDhaIWzlN_WngLcMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/user-help-desk/faq/index.vue?macro=true";
import { default as indexlbzqBWiJ2FwrXJiVqdzDHyCrD3YlvREn9Y8pvDV21nsMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/drivers-and-manuals/index.vue?macro=true";
import { default as _91slug_93ah1MvgrZj_45RBdGoFntbv5kmrvEJIxs19Jh4N2NB4aYQMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/user-help-desk/faq/[slug].vue?macro=true";
import { default as indexIXTABngEE_Y3UUTl2HogH60xl1Mxas_45mOwyxQRve_4528Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/product-category/[category]/index.vue?macro=true";
import { default as indexHMVCOrssh76zA3H6WAVi_txE_456tV259CcpJcIjn1qmgMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/product-category/[category]/[subcategory]/index.vue?macro=true";
import { default as indexFn1gI8kniGflVrvzVo_45tUDs5nmltx4sVQoDD3i0u4_45EMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/product-category/[category]/[subcategory]/[subsubcategory]/index.vue?macro=true";
import { default as index7ArelpDUEhkFuedEHmmpb686JM6fK3SVwunX269NwFEMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/product-category/[category]/[subcategory]/[subsubcategory]/[subsubsubcategory]/index.vue?macro=true";
export default [
  {
    name: "about___en",
    path: "/about/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/about.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/index.vue")
  },
  {
    name: "slug___en",
    path: "/:slug()/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/[slug].vue")
  },
  {
    name: "search___en",
    path: "/search/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/search.vue"),
    children: [
  {
    name: "search-faqs___en",
    path: "faqs/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/search/faqs.vue")
  },
  {
    name: "search-news___en",
    path: "news/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/search/news.vue")
  },
  {
    name: "search-drivers___en",
    path: "drivers/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/search/drivers.vue")
  },
  {
    name: "search-products___en",
    path: "products/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/search/products.vue")
  }
]
  },
  {
    name: "contact-us___en",
    path: "/contact-us/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/contact-us.vue")
  },
  {
    name: "news___en",
    path: "/news/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/news/index.vue")
  },
  {
    name: "e-catalogue___en",
    path: "/e-catalogue/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/e-catalogue.vue")
  },
  {
    name: "news-slug___en",
    path: "/news/:slug()/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/news/[slug].vue")
  },
  {
    name: "promo___en",
    path: "/promo/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/promo/index.vue")
  },
  {
    name: "promo-slug___en",
    path: "/promo/:slug()/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/promo/[slug].vue")
  },
  {
    name: "product-slug___en",
    path: "/product/:slug()/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/product/[slug].vue")
  },
  {
    name: "certificates___en",
    path: "/certificates/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/certificates/index.vue")
  },
  {
    name: "where-to-buy___en",
    path: "/where-to-buy/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/where-to-buy/index.vue")
  },
  {
    name: "certificates-slug___en",
    path: "/certificates/:slug()/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/certificates/[slug].vue")
  },
  {
    name: "user-help-desk___en",
    path: "/user-help-desk/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/user-help-desk/index.vue")
  },
  {
    name: "account-removal-request___en",
    path: "/account-removal-request/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/account-removal-request.vue")
  },
  {
    name: "user-help-desk-faq___en",
    path: "/user-help-desk/faq/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/user-help-desk/faq/index.vue")
  },
  {
    name: "drivers-and-manuals___en",
    path: "/drivers-and-manuals/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/drivers-and-manuals/index.vue")
  },
  {
    name: "user-help-desk-faq-slug___en",
    path: "/user-help-desk/faq/:slug()/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/user-help-desk/faq/[slug].vue")
  },
  {
    name: "product-category-category___en",
    path: "/product-category/:category()/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/product-category/[category]/index.vue")
  },
  {
    name: "product-category-category-subcategory___en",
    path: "/product-category/:category()/:subcategory()/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/product-category/[category]/[subcategory]/index.vue")
  },
  {
    name: "product-category-category-subcategory-subsubcategory___en",
    path: "/product-category/:category()/:subcategory()/:subsubcategory()/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/product-category/[category]/[subcategory]/[subsubcategory]/index.vue")
  },
  {
    name: "product-category-category-subcategory-subsubcategory-subsubsubcategory___en",
    path: "/product-category/:category()/:subcategory()/:subsubcategory()/:subsubsubcategory()/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/pages/product-category/[category]/[subcategory]/[subsubcategory]/[subsubsubcategory]/index.vue")
  }
]